import { render, staticRenderFns } from "./Busqueda.vue?vue&type=template&id=1a5e0899"
import script from "./Busqueda.vue?vue&type=script&lang=js"
export * from "./Busqueda.vue?vue&type=script&lang=js"
import style0 from "./Busqueda.vue?vue&type=style&index=0&id=1a5e0899&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports